import { render, staticRenderFns } from "./added-service.vue?vue&type=template&id=5db0d73d&"
import script from "./added-service.js?vue&type=script&lang=js&"
export * from "./added-service.js?vue&type=script&lang=js&"
import style0 from "./added-service.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports